import { Table, Text } from '@factorialco/deprecated-design-system'

import type { LegalEntities } from 'modules/core/store/collections/legalEntities'

import { ContractTaxonomy } from 'modules/contracts/hooks/useFetchContractsTaxonomies'
import { ReimbursableSupplementTaxonomyMapping } from 'modules/payroll_bundle/hooks/useFetchReimbursableSupplementMappings'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import TimeMappingDropdown from './TimeMappingDropdown'

interface TaxonomiesByLegalEntity {
  [key: number]: ContractTaxonomy[]
}

interface Props {
  timeRangeCategory: CustomTimeRangeCategory
  legalEntities: LegalEntities
  taxonomiesByLegalEntity: TaxonomiesByLegalEntity
  mappings: ReimbursableSupplementTaxonomyMapping[]
}

const TimeMappingsRow = ({
  timeRangeCategory,
  legalEntities,
  taxonomiesByLegalEntity,
  mappings,
}: Props) => {
  const mapping = (legalEntityId: string) =>
    mappings.find(
      (_mapping) =>
        _mapping.legalEntityId === legalEntityId &&
        _mapping.reimbursableId === timeRangeCategory.id.toString()
    )

  return (
    <Table.Row>
      <Table.Cell sticky={{ position: 'left', delimiter: true }}>
        <Text.Normal>{timeRangeCategory.name}</Text.Normal>
      </Table.Cell>
      {legalEntities.map((legalEntity) => (
        <Table.Cell key={`legal_entity_${legalEntity.id}`}>
          <TimeMappingDropdown
            timeRangeCategoryId={timeRangeCategory.id}
            legalEntityId={legalEntity.id}
            taxonomies={taxonomiesByLegalEntity[legalEntity.id] || []}
            mapping={mapping(legalEntity.id.toString())}
          />
        </Table.Cell>
      ))}
    </Table.Row>
  )
}

export default TimeMappingsRow
